// extracted by mini-css-extract-plugin
module.exports = {"horario":"Horario_horario__uiFJ6"};